import { TrackingEvent } from '@owc/connection-aem-tracking'
import { EventDetail } from './interface'
import packageMeta from '../../package.json'

export const analyticsEvt = (eventDetail: EventDetail): TrackingEvent => {
  if (!eventDetail.URL) delete eventDetail.URL
  return {
    event: 'click',
    eventDetail,
    application: {
      id: 'reachme',
      version: packageMeta.version,
    },
  }
}
